
import { getToken } from '../auth/auth';
import { buildApiUrl } from '../config/runtime';
import { ApiError } from './errors';

export const apiFetch = async (path, options = {}) => {
    const url = buildApiUrl(path);

    const headers = {
        ...options.headers,
    };

    // If body is not FormData and Content-Type is not set, default to JSON
    if (!(options.body instanceof FormData) && !headers['Content-Type']) {
        headers['Content-Type'] = 'application/json';
    }

    const response = await fetch(url, {
        ...options,
        headers,
    });

    if (!response.ok) {
        let detail = 'API request failed';
        let code = 'api_request_failed';
        try {
            const errorData = await response.json();
            code = errorData.error_code || errorData.code || errorData.detail?.error_code || errorData.detail?.code || code;
            detail = typeof errorData.detail === 'string'
                ? errorData.detail
                : errorData.error || detail;
        } catch (e) { }
        throw new ApiError(code, response.status, detail);
    }

    return response.json();
};

export const apiFetchAuth = async (path, options = {}) => {
    const token = getToken();

    if (!token) {
        throw new Error('No access token found');
    }

    const headers = {
        'Authorization': `Bearer ${token}`,
        ...options.headers,
    };

    return apiFetch(path, { ...options, headers });
};


export const apiFetchGuest = async (path, options = {}) => {
    const { getGuestPaymentId } = await import('../payments/guestIdentity.js');
    const headers = {
        'X-Guest-Id': getGuestPaymentId(),
        ...options.headers,
    };
    return apiFetch(path, { ...options, headers });
};

export const apiFetchPayment = async (path, options = {}) => {
    const token = getToken();
    const headers = { ...options.headers };
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    } else {
        const { getGuestPaymentId } = await import('../payments/guestIdentity.js');
        headers['X-Guest-Id'] = getGuestPaymentId();
    }
    return apiFetch(path, { ...options, headers });
};
